(function () {
    'use strict';

    angular
        .module('emails')
        .controller('ViewEmailCampaignController', ViewEmailCampaignController);

    ViewEmailCampaignController.$inject = ['$uibModalInstance', 'campaign','$sce','$scope'];

    function ViewEmailCampaignController($uibModalInstance, campaign, $sce, $scope) {
        var vm = this;
        vm.campaign = campaign;
        vm.ok = ok;
        vm.cancel = cancel;

        $scope.trustAsHtml = function(string) {
            return $sce.trustAsHtml(string);
        };
        activate();

        function activate() {
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();